import React from "react";
import { Container } from "react-bootstrap";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "./brandagreement.css";

const BrandAgreement = () => {
  return (
    <div className="terms_section">
      <div className="terms">
        <Header />
        <Container>
          <h4>
            <b>SPLENDID APP TERMS & CONDITIONS</b>
          </h4>
          <h6 className="py-5">
            <b>
              Note: THIS DOCUMENT IS AN ELECTRONIC RECORD IN TERMS OF THE INFORMATION TECHNOLOGY
              ACT, 2000 AND RULES MADE THEREUNDER. THIS ELECTRONIC RECORD IS GENERATED BY A COMPUTER
              SYSTEM AND DOES NOT REQUIRE ANY PHYSICAL OR DIGITAL SIGNATURES. THESE TERMS OF USE
              WERE UPDATED ON NOVEMBER 2021. PLEASE CAREFULLY READ THESE TERMS OF USE. BY USING THIS
              PLATFORM, YOU INDICATE YOUR UNDERSTANDING AND ACCEPTANCE OF THESE TERMS. IF YOU DO NOT
              AGREE TO THESE TERMS, YOU MAY NOT USE THIS PLATFORM
            </b>
          </h6>
          <p>MERCHANT/ BRAND AGREEMENT</p>
          <p>
            This Agreement is entered in Mumbai on ______ Day of ________, in the Christian year
            ______;
          </p>
          <p>BY AND BETWEEN:</p>
          <p>
            SPLENDID APP PRIVATE LIMITED, a company registered under the Indian Companies Act 2013
            bearing Corporate Identification Number (CIN) U62099KA2024PTC185719 and having
            registered office at 235, Binnamangala, 2nd Floor 13th Cross Road, 2nd Stage Indiranagar
            (Bangalore) Bangalore North Bangalore KA 560038 IN represented through directors Nirmal
            Kotecha and Warren Menezes, hereinafter referred to as “COMPANY” (which expression shall
            unless being repugnant to the context or meaning thereof shall mean and include its
            directors, representatives, executors) OF
          </p>
          <p>THE FIRST PART;</p>
          <p>AND</p>
          <p>
            Mr./Mrs. ___________________________, habitant of __________, having identity proof as
            ____________ having number ____________, and having an address at office at
            _________________________, hereinafter referred to as “MERCHANT/ CREATOR” (which
            expression shall unless be repugnant to the context or meaning thereof shall mean and
            include his/her self or his authorized assignee) OF THE OTHER PART;Mr./Mrs.
            ___________________________, habitant of __________, having identity proof as
            ____________ having number ____________, and having an address at office at
            _________________________, hereinafter referred to as “MERCHANT/ CREATOR” (which
            expression shall unless be repugnant to the context or meaning thereof shall mean and
            include his/her self or his authorized assignee) OF THE OTHER PART;
          </p>
          <p>OR</p>
          <p>
            M/s _________________________, a company incorporated under the Indian Companies Act,
            1956 or Companies Act 2013, or Limited Liability Partnership Act, 2008 having CIN No.
            _____________________, PAN card No. ___________________, represented through its
            designated partner/director/authorized signatory ____________________ authorized by a
            board resolution dated ________________, having registered office address at
            _____________________________________________, hereinafter referred to as
            “MERCHANT/CREATOR” (which expression shall unless be repugnant to the context or meaning
            thereof shall mean and include its directors or partners or designated partners,
            officers, representatives and/or assignee) OF THE OTHER PART;
          </p>
          <p>OR</p>
          <p>
            M/s _________________________, a partnership firm, incorporated under Indian Partnership
            Act, 1932, having PAN card No. ___________________, represented through its partner
            _________________, having registered office address at
            _____________________________________________, hereinafter referred to as
            “MERCHANT/CREATOR” (which expression shall unless repugnant to the context or meaning
            thereof mean an include its directors, officers, representatives, and/or assignee) OF
            THE OTHER PART;
          </p>
          <p>OR</p>
          <p>
            M/s _________________________, a company/ firm incorporated under ___________, having
            identification No. _____________________, represented through ____________________
            authorized by a board resolution dated ________________, having registered office
            address at _____________________________________________, hereinafter referred to as
            “MERCHANT/BRAND/CREATOR” (which expression shall unless be repugnant to the context or
            meaning thereof mean and include its directors, officers, representatives and/or
            assignee) OF THE OTHER PART;
          </p>
          <p>WHEREAS: -</p>
          <ol>
            <li>
              The company is engaged in the business of providing social commerce platform services
              content production, marketing, booking, customer care, product research activities for
              customers and support services, sales, commercial events, administration, planning,
              financial, legal, market development, advertisement, product development, product
              support, systems development, operations support, project related matters, provision
              of training, information on competitive activities, promotional offers, collection of
              industry data, answering operational, technical and risk management queries and other
              related business activities (“the said business activities”) under name and style of
              “SPLENDID”. The Company has full rights and complete ownership rights to enter into
              this contract with Merchant/Creators.
            </li>
            <li>
              Merchant/Creator has approached the Company to promote the said business activities on
              the digital platform of the company.
            </li>
            <li>
              Merchant/Creator has agreed to pay commission and other charges as applicable to them
              under this agreement for using the said platform for marketing, display of creative
              content, selling goods, and other things as agreed between the parties as legally
              permissible by MOA/AOA of the company and legally permissible by law prevailing in
              Union of India.
            </li>
            <li>
              The merchant/ Creator has represented those personal details and other information
              provided by them in the execution of this electronic agreement as true and correct and
              relying on the representations of the merchant/user, the company has entered into this
              agreement without verifying the contents of the information provided by
              merchant/creator. In no circumstances, the company shall be liable for actions,
              misdeeds, misrepresentations, or fraud committed by the merchant/creator knowingly or
              unknowingly while using the digital platform of the company. Merchant shall at all
              times indemnify the company, its officers, agents, directors, representatives, and
              assignees from every action undertaken by the Merchant/Creator on the digital
              platform.
            </li>
            <li>
              The merchant/Creator has satisfied themselves with their responsibilities under this
              agreement and has entered into this agreement after reading and understanding the role
              of the merchant/creator and acknowledging the fact the company is only a facilitator
              to the merchant/creator.
            </li>
            <li>
              Parties have agreed to enter into this agreement and have agreed to agree to the terms
              and conditions of this agreement which are produced in detail hereinbelow.
            </li>
            <li>
              <div className="bottom-space">
                <p>
                  Creators, Merchants, or Artists: A creator is someone who creates and provides
                  content or services for their subscribers or customers through the splendid
                  platform. To become a creator, you must create a page (also called a creator's
                  website) that describes what you are creating and any benefits you are offering.
                  To receive pay-outs, you have to provide us with your preferred payment mode with
                  your details e.g., UPI / Bank Transfer, etc. You must also provide us with
                  additional information for tax purposes.
                </p>{" "}
              </div>
              <ul>
                <li>Legal name</li>
                <li>Address Proof</li>
                <li>PAN Card / Aadhar Card</li>
                <li>GST (if required)</li>
                <li>FSSAI (if required)</li>
              </ul>
            </li>
          </ol>

          <p>
            NOW THEREFORE THE PARTIES HEREBY AGREE to execute the Agreement in consideration of the
            mutual promises, covenants, representations, and warranties and by the terms and
            conditions set out hereunder:
          </p>
          <ol>
            <li>
              Recitals shall form an integral part of this agreement and shall be read as a part of
              this agreement. Recitals shall be representations of the parties which shall be
              binding upon the parties.
            </li>
            <li>
              <div className="bottom-space">
                <p>INTELLECTUAL PROPERTY</p>
              </div>
              <ol type="a">
                <li>
                  Company has the right, title, and interest including but not limited to ownership
                  of domain rights of www.splendid.app and trademark, logos, graphics, images, sound
                  recordings, audio-visual works, and other material works owned and related to the
                  company (“intellectual property of the company”) excluding content of merchant or
                  creator protected under copyright laws prevailing in the territory, displayed on
                  the registered website and mobile application of the website. No creator or
                  merchant or any person or persons under him shall claim or claim any right, title,
                  or interest upon the intellectual property of the company save and except content
                  uploaded on the website of the company protected under copyright laws prevailing
                  in the territory of India.
                </li>
                <li>
                  Any right, title, and interest whatsoever, including, but not limited to content,
                  patents, copyright, trade secrets, IT solutions, software, and design rights
                  whether capable of being registered or not, arising or created produced by the
                  Merchant or Creator shall belong to Merchant or Creator exclusively.
                </li>
                <li>
                  Merchant/ Creator undertakes not to sell, transfer, assign, license, sublicense,
                  or modify the intellectual property of the company without express written
                  permission of the company.
                </li>
              </ol>
            </li>
            <li>
              <div className="bottom-space">CONFIDENTIALITY:</div>
              <div className="bottom-space">
                <p>
                  “Confidential Information” includes, without limitation, all information that has
                  or could have commercial value or other utility in which the Merchant or creator
                  or any of its representative/Affiliate/authorized officer is engaged or in which
                  they contemplate engaging, which shall include:
                </p>
              </div>
              <ol type="a">
                <li>
                  Testing methods, content, patents, copyright, trade secrets, IT solutions,
                  software and design, and other intellectual property rights of the company
                  displayed on the website and mobile application of the company save and except
                  content uploaded on the website of the company protected under copyright laws
                  prevailing in the territory of India.
                </li>
                <li>
                  All information of which the unauthorized disclosure could be detrimental to the
                  interest of the company, whether or not such information is identified as
                  Confidential Information by the employer.
                </li>
                <li>
                  Information disclosed by merchants or creators including communications between
                  the company and merchant or creators during the subsistence of this agreement
                  which is not expressly permitted.
                </li>
                <li>
                  Information disclosed or made available to the merchant or creator by the company.
                </li>
                <li>
                  All information about the commission, fees, charges, payments, services, and other
                  commercial understanding between the company and merchant or creator communicated
                  expressly or impliedly by the company.
                </li>
                <li>
                  <div className="bottom-space">
                    <p>It does not include except and then only to the extent that:</p>
                  </div>{" "}
                  <ul>
                    <li>
                      Merchant or creator can demonstrate by competent written proof that all or any
                      part of the confidential information was already in his/ their at the time
                      before its disclosure by the company. Or;
                    </li>
                    <li>
                      All or any part of the Confidential Information can be demonstrated by
                      competent written proof to be in the public domain.
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li>
              <div className="bottom-space">
                <p>KYC AND CREATOR VERIFICATION</p>
              </div>

              <p>
                Any merchant or creator using the digital platform of the company shall complete the
                KYC as per annexures to this agreement and render true and correct information to
                the company. in case any merchant or vendor renders false information or fails to
                complete KYC then it shall result in suspension of account and forfeiture of any
                earning or pay-off to the merchant or creator.
              </p>
            </li>
            <li>
              <div className="bottom-space">
                <p>WHO CAN NOT USE THE PLATFORM OF THE COMPANY</p>
              </div>
              <div className="bottom-space">
                <p>All persons are allowed to use the digital platform of the company except:</p>
              </div>

              <ol type="a">
                <li>
                  People using the platform to advance political views and/or run, and manage
                  political campaigns save and accept educational videos about current affairs in
                  India and in the entire world.
                </li>
                <li>
                  Persons or organizations already convicted for criminal or harmful posts and/or
                  crimes punishable under the Indian Penal Code or any other criminal law prevailing
                  in India;
                </li>
                <li>
                  People or organizations promoting drugs, substance abuse, nudity, sexuality,
                  terrorism, sedition, supply of weapons, white collar crimes, abuse of children,
                  abuse of animals;
                </li>
                <li> People debarred by the company for non-compliance to this agreement </li>
              </ol>
            </li>
            <li>
              <div className="bottom-space">
                <p>REFUND AND CANCELLATION</p>
              </div>
              <ol type="a">
                <li>
                  No Refund of creator/ merchant and/or end user shall be granted by the company.
                </li>
                <li>
                  In the event the merchant or creator wants to stop the subscription or service
                  provided by the company, the creator or merchant shall use the tools provided on
                  the platform.
                </li>
                <li>
                  Any Account not recharged for more than 2 (two)weeks will automatically delete its
                  contents. The company shall not be liable for deletion of contents or
                  de-activation of such dormant accounts.
                </li>
                <li>
                  Brands for marketing / PPC campaigns, cannot withdraw any funds added to the
                  system. Unused balance can be used by the brand in subsequent campaigns. In the
                  scenario of the brand terminating its contract with the platform, a formal request
                  for a refund of balance can be made to the app management team. Any refund granted
                  is at the sole discretion of the company.
                </li>
              </ol>
            </li>
            <li>
              <div className="bottom-space">
                <p>TERMINATION</p>
              </div>
              <ol type="a">
                <li>
                  If the Merchant, Brand or Creator is guilty of any misconduct or commits a breach
                  of any provision of this Agreement or annexure attached hereto, the company shall
                  have complete right and full authority to terminate this agreement without any
                  prior notice and de-active the account of such merchant or creator. However, the
                  merchant or creator shall be allowed to activate his account again and enter into
                  a new agreement or resume performance under this agreement as decided by the
                  company from time to time or as per guidelines issued by the company.
                </li>
                <li>
                  In the event the merchant or creator requests for termination of this agreement or
                  unilaterally de-activates the account to play fraud on the customers using the
                  digital platform of the company for wrongful gains. In such event, the Merchant or
                  creator shall be disbarred from using the digital platform of the company for a
                  period as decided from time to time and shall be liable to compensate the company
                  damages equivalent to 100% of the sale proceeds of the merchant or creator for
                  loss of goodwill, reputation of the company. In case of any such fraud by the
                  Merchant or creator on his customers, such merchant or creator shall indemnify and
                  keep indemnified the company, its director, agents, representatives, and officers
                  from all claims, demands, damages, legal proceedings, costs which is liable to
                  paid by the merchant or creator.
                </li>
                <li>
                  The Company shall have the right to exercise a lien on all amounts due to the
                  Merchant or creator from the company in respect of the damages aforesaid.
                </li>
                <li>
                  This agreement between the parties shall stand terminated on non-usage of a
                  digital platform for a continuous period of 3 months by the Merchant or Creator.
                </li>
              </ol>
            </li>
            <li>
              <div className="bottom-space">
                <p>REPRESENTATIONS AND WARRANTIES</p>
              </div>
              <div className="bottom-space">
                <p>Merchant or creator hereby represents and warrants to the Company as follows:</p>
              </div>

              <ol type="a">
                <li>
                  The Merchant or creator has accurately disclosed all information to the Company at
                  the time of entering into this agreement, including information about legal
                  identity, personal information, bank account information, GST number, and
                  employment status.
                </li>
                <li>
                  Merchant or creator is not subject to any agreement, arrangement, contract,
                  understanding, court order, or otherwise, which in any way directly or indirectly
                  restricts or prohibits the Merchant or creator from fully performing the duties
                  under this agreement or any of them, following the terms and conditions of this
                  agreement.
                </li>
                <li>
                  Merchant or Employer hereby represents that he is not in employment (whether full
                  or part-time) with any other person, firm, company, or organization as of the date
                  hereof.
                </li>
                <li>
                  Merchant or creator is not barred or blacklisted by any governmental body,
                  statutory authority, social platforms, or websites including Twitter, Facebook,
                  Instagram, amazon, Flipkart, etc and no show-cause notice in respect thereof has
                  been issued to the Merchant or creator.
                </li>
                <li>
                  Merchant or creator is not convicted by any court or tribunal of any offense under
                  the laws of India.
                </li>
              </ol>
            </li>
            <li>
              <div className="bottom-space">
                <p>INDEMNITY</p>
              </div>
              <span>
                <p>
                  Merchant or creator hereby indemnifies and holds harmless and agrees and
                  undertakes with the Company that the Merchant or creator shall and will from time
                  to time and at all times hereafter, indemnify and fully and effectively keep them
                  indemnified and save harmless the Company and from and against all actions, suits,
                  prosecutions, proceedings, claims and demands whatsoever that may be made, raised
                  or preferred by any persons against Company or its directors, officers,
                  representatives, agents, authorized representatives, signatories and also against
                  all costs, losses, charges, expenses, damages, claims or payments whatsoever that
                  they may be made liable to pay, suffer or incur consequent upon breach by the
                  Merchant or Creator of this Agreement or any representation, warranty or statement
                  contained in this Agreement made by the Employee found to be untrue or inaccurate.
                  Merchant or creator agrees and undertakes to company to bear and pay all costs,
                  charges, expenses, losses, claims, and damages that Company or its directors,
                  officers, representatives, agents, authorized representatives, signatories may
                  suffer or incur on that behalf, including legal costs and attorney's fees.
                </p>
              </span>
            </li>
            <li>
              <div className="bottom-space">
                <p>NOTICES</p>
              </div>
              <span>
                <p>
                  Any notice or other communication of like nature that may be given by one party to
                  the other shall always be in writing in English and shall be served by email or
                  hand delivery duly acknowledged or sent by Registered Post with acknowledgment due
                  or by an email or by courier at the respective addresses recorded in the address
                  above mentioned by the parties.
                </p>
              </span>
            </li>
            <li>
              <div className="bottom-space">
                <p>INDEPENDENT CONTRACTORS</p>
              </div>
              <span>
                <p>
                  The Company and the Merchant or creator are each independent contractors and this
                  Agreement shall not be construed to create an association, partnership, joint
                  venture, relation of principal and agent, or employer and employee between the
                  Parties or its agents within the meaning of any applicable law. Neither party will
                  enter into any agreement, oral or written, on behalf of the other or otherwise
                  obligate the other party without that party's advance written approval.
                </p>
              </span>
            </li>
            <li>
              <div className="bottom-space">
                <p>CODE OF CONDUCT</p>
              </div>
              <span>
                <p>
                  Merchants or creators shall refrain from using the services given by the company
                  to promote unlawful, illegal activities, unwanted marketing, email spamming,
                  abusive language, and sexual content (express or implied).
                </p>
              </span>
            </li>
            <li>
              <div className="bottom-space">
                <p>ENTIRE AGREEMENT</p>
              </div>
              <span>
                <p>
                  The Agreement along with Applicable annexures shall contain the entire agreement
                  between the Parties, superseding in all respects any prior oral or written
                  agreements or understandings, and shall be amended modified, or extended only by
                  written instrument signed by both Parties.
                </p>
              </span>
            </li>
            <li>
              <div className="bottom-space">
                <p>SEVERABILITY</p>
              </div>
              <span>
                <p>
                  If any of the provisions of the Agreement are found to be unenforceable, the
                  remainder shall be enforced as fully as possible and the unenforceable
                  provision(s) shall be deemed modified to the limited extent required to permit
                  enforcement of the Agreement as a whole.
                </p>
              </span>
            </li>
            <li>
              <div className="bottom-space">
                <p>ARBITRATION</p>
              </div>
              <ol type="a">
                <li>
                  If any dispute or difference cannot be resolved amicably, the Parties agree to
                  resolve the dispute and difference through arbitration according to the provisions
                  of the Arbitration and Conciliation Act, 1996, or any statutory modification or
                  re-enactment thereof.
                </li>
                <li>The venue of such Arbitration shall be Mumbai.</li>
                <li> The language of Arbitration shall be English. </li>
                <li>
                  The Agreement and the rights and obligations of the Parties shall remain in full
                  force and effect, pending the Award in any arbitration proceedings hereunder.
                </li>
                <li>The entire cost of arbitration shall be paid by the Employee.</li>
              </ol>
            </li>
            <li>
              <div className="bottom-space">
                <p>GOVERNING LAW AND JURISDICTION</p>
              </div>
              <ol type="a">
                <li>The agreement shall be governed and construed per the laws of India.</li>
                <li>
                  If any action or proceeding arising out of or related to the Agreement is brought
                  by either Party; subject to the arbitration clause above, the Parties consent to
                  the exclusive jurisdiction and venue in the courts of Mumbai.
                </li>
              </ol>
            </li>
          </ol>
          <p>
            <span>
              <b>IN WITNESS WHEREOF, </b>
            </span>
            the Parties have entered into the Agreement the day and year first above written at
            Mumbai
          </p>
          <table className="agreement-table">
            <tr>
              <td>
                <div>
                  <h2 className="text-start mb-5">
                    SIGNED SEALED AND DELIVERED BY SPLENDID APP PRIVATE LIMITED BY WITHIN NAMED "THE
                    COMPANY "
                  </h2>

                  <div className="seal-gap text-start">
                    <p>
                      The Agreement is being signed by me at my free will and without any pressure
                      or coercion on anybody's part, at Mumbai. The Agreement will also constitute
                      as part and parcel of the terms of employment of employer as aforesaid.
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <h2 className="text-start">
                  SIGNED SEALED AND DELIVERED BY____________________BY WITHINAMED CALLED “MERCHANT
                  OR CREATOR”
                </h2>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <h3>
                  Note: THIS DOCUMENT IS AN ELECTRONIC RECORD IN TERMS OF THE INFORMATION TECHNOLOGY
                  ACT, 2000 AND RULES MADE THEREUNDER. THIS ELECTRONIC RECORD IS GENERATED BY A
                  COMPUTER SYSTEM AND DOES NOT REQUIRE ANY PHYSICAL OR DIGITAL SIGNATURES. THESE
                  TERMS OF USE WERE UPDATED ON NOVEMBER 2021. PLEASE CAREFULLY READ THESE TERMS OF
                  USE. BY USING THIS PLATFORM, YOU INDICATE YOUR UNDERSTANDING AND ACCEPTANCE OF
                  THESE TERMS. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT USE THIS PLATFORM
                </h3>
              </td>
            </tr>
          </table>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default BrandAgreement;
